import CurrentOrganizationContext, {
	type CurrentOrganizationContextValue,
} from '@UI/Providers/CurrentOrganizationProvider/CurrentOrganizationContext';
import * as React from 'react';

function useCurrentOrganization(): CurrentOrganizationContextValue {
	const context = React.useContext(CurrentOrganizationContext);

	if (context === null) {
		throw new Error('useCurrentOrganization must be used within a CurrentOrganizationProvider.');
	}

	return context;
}

export default useCurrentOrganization;
